import { Injectable } from '@angular/core';
import { DecisionRecord } from '../models/decision.model';

@Injectable({ providedIn: 'root' })
export class PlayerDataService {
  //private decisionData: Record<string, any> = {};
  private currentDecision: DecisionRecord | null = null;

  setPageDecisionData(pgnm: string, data: any) {
    if (!this.currentDecision) return;
    console.log("set page decision for" + pgnm);
    // this.setvalsforentry();
    console.log(data);
    const section = this.currentDecision.sections.find(s => s.sectionName === pgnm);
    if (section) {
      section.data = JSON.parse(JSON.stringify(data)); // deep clone // merge new values
    }
    //this.decisionData[pgnm] = data;
  }

  getPageDecisionData(pgnm: string): Record<string, any> | null {
    console.log("getting for " + pgnm);
    return this.currentDecision?.sections.find(s => s.sectionName === pgnm)?.data || null;
  }

  getAllData() {
    return this.currentDecision;
  }
  setDecision(data: any) {
    this.currentDecision = data;
  }

  setvalsforentry() {
    debugger;
    if (this.currentDecision?.header.status == 'Y' || this.currentDecision?.header.status == 'E') {
      // we are in entry mode - we shoudl take [roduct names and place them in production decision etc]
      const entrySection = this.currentDecision.sections.find((s: any) => s.sectionName === 'entry');
      const Product1Name = entrySection?.data['Product1Name'];
      const Product2Name = entrySection?.data['Product2Name'];
      const companyname = entrySection?.data['CompanyName'];
      const Nooffact = entrySection?.data['Nooffact'];

      console.log(Product1Name);
      console.log(Product2Name);
      const prodDSection = this.currentDecision.sections.find((s: any) => s.sectionName === 'production');
      if (prodDSection) {
        prodDSection.data['allocations'][0]['productName'] = Product1Name;
        prodDSection.data['allocations'][1]['productName'] = Product2Name;
        prodDSection.data['F_current'] = Nooffact;
        console.log("factories ");
        console.log(Nooffact);
        console.log("production set");
      }

      const mktgDSection = this.currentDecision.sections.find((s: any) => s.sectionName === 'marketing');
      if (mktgDSection) {
        mktgDSection.data['brandPromotion'][0]['productName'] = companyname;
        mktgDSection.data['brandPromotion'][1]['productName'] = Product1Name;
        mktgDSection.data['brandPromotion'][2]['productName'] = Product2Name;
        console.log("mktg set");
      }
      const productDSection = this.currentDecision.sections.find((s: any) => s.sectionName === 'product');
      if (productDSection) {
        productDSection.data[0]['productName'] = Product1Name;
        productDSection.data[1]['productName'] = Product2Name;
        console.log("finally");
      }


    }

  }

  setFullDecisionData(data: any) {
    console.log("set full decision");
    console.log(data);
    if (!this.currentDecision) return;
    console.log(data);
    this.currentDecision.header.BatchId = data.BatchId;
    this.currentDecision.header.CompanyId = data.CompanyId;
    this.currentDecision.header.RoundId = data.RoundId;
    this.currentDecision.header.status = data.Status;
    this.currentDecision.sections[7].sectionName = 'readonly';
    this.currentDecision.sections[7].data = JSON.parse(data.readOnlyVals);
    console.log(data.readOnlyVals);
    console.log(this.currentDecision.sections[7].data);
    this.currentDecision.sections[1].sectionName = 'finance';
    this.currentDecision.sections[1].data = JSON.parse(data.financeDecisions);
    console.log(data.financeDecisions);
    console.log(this.currentDecision.sections[1].data);
    this.currentDecision.sections[0].sectionName = 'entry';
    this.currentDecision.sections[0].data = JSON.parse(data.entryDecisions);
    this.currentDecision.sections[2].sectionName = 'people';
    this.currentDecision.sections[2].data = JSON.parse(data.peopleDecisions);
    this.currentDecision.sections[3].sectionName = 'randd';
    this.currentDecision.sections[3].data = JSON.parse(data.RandDDecisions);
    this.currentDecision.sections[4].sectionName = 'production';
    this.currentDecision.sections[4].data = JSON.parse(data.productionsDecisions);
    this.currentDecision.sections[5].sectionName = 'product';
    this.currentDecision.sections[5].data = JSON.parse(data.productDecisions);
    this.currentDecision.sections[6].sectionName = 'marketing';
    this.currentDecision.sections[6].data = JSON.parse(data.marketingDecisions);

    console.log(this.currentDecision);
  }
}
